(() => {
  const aliases = window.HayzCompleteSources || {};
  const sourceName = value => {
    try { return new URL(value, location.href).pathname.split('/').pop(); } catch (_) { return ''; }
  };
  const lookup = value => aliases[sourceName(value)] || null;
  const resize = (value, width) => {
    const replacement = lookup(value);
    const url = new URL(replacement?.url || value, location.href);
    ['crop','crop_left','crop_top','crop_width','crop_height'].forEach(key => url.searchParams.delete(key));
    const size = Math.min(replacement?.width || 2048, Math.ceil(width || 1254));
    url.searchParams.set('width', size);
    if (url.searchParams.has('pad_color')) url.searchParams.set('height', size);
    else url.searchParams.delete('height');
    return url.href;
  };
  const style = (img, entry) => {
    img.style.objectFit = 'contain'; img.style.objectPosition = 'center';
    img.style.transform = 'none';
    if (entry?.width) { img.width = entry.width; img.height = entry.height; }
    const frame = img.closest('.hayz-photo-window,.hayz-card-frame');
    if (frame && entry?.background) frame.style.backgroundColor = entry.background;
    img.style.maskImage = 'none'; img.style.webkitMaskImage = 'none';
  };
  const apply = img => {
    if (!(img instanceof HTMLImageElement)) return;
    // Gallery sources are sized once before decode; the observer must not cancel a transition.
    if (img.dataset.hayzGalleryManaged === 'true') {
      style(img, lookup(img.dataset.hayzOriginalSource)); return;
    }
    const original = img.dataset.hayzOriginalSource || img.getAttribute('src') || img.currentSrc;
    const entry = lookup(original);
    if (!entry) return;
    const currentName = sourceName(img.getAttribute('src'));
    if (img.dataset.hayzOriginalSource && currentName !== sourceName(original) && currentName !== sourceName(entry.url)) {
      delete img.dataset.hayzOriginalSource; apply(img); return;
    }
    img.dataset.hayzOriginalSource = original;
    const width = Math.min(entry.width, Math.max(600, Math.ceil((img.clientWidth || 600) * (window.devicePixelRatio || 1))));
    const target = resize(original, width);
    if (img.getAttribute('src') !== target) img.setAttribute('src', target);
    img.removeAttribute('srcset'); img.removeAttribute('sizes');
    img.closest('picture')?.querySelectorAll('source').forEach(source => source.removeAttribute('srcset'));
    style(img, entry);
  };
  window.HayzCompletePhotos = Object.freeze({lookup, resize, style});
  const run = root => {
    if (root instanceof HTMLImageElement) apply(root);
    root.querySelectorAll?.('img').forEach(apply);
  };
  run(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') apply(record.target);
      else record.addedNodes.forEach(run);
    });
  }).observe(document.documentElement, {subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset']});
  document.addEventListener('shopify:section:load', event => run(event.target));
})();
